import type { FC } from "react";

import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { AntCustomFormField } from "../../types/types";
import { IdGenerator } from "../IdGenerator/IdGenerator";

export interface InputGeneratorProps extends AntCustomFormField<string> {
    label: string;
    readOnly: boolean;
    name: string;
    orgUnitId: number;
    terminalId: number;
}

export const TerminalIdCopyGenerator: FC<InputGeneratorProps> = ({ orgUnitId, terminalId, ...restProps }) => {
    const fetchUrl = `/${ResourceName.TERMINAL_COPY_ID_GENERATOR}?orgUnitId=${orgUnitId}&terminalId=${terminalId}`;

    return <IdGenerator fetchUrl={fetchUrl} buttonName="terminalIdGenerator_button" showSpinner {...restProps} />;
};
